import { COU_httpGet, COU_httpPost } from "@/utils/http";
import store from "@/store";
import { Service_GetBranchRelId } from '@/service/branch_relId_service';

// 获取搬运操作日志列表
async function GetLogList(data = {}) {
  const checkMall = store.state["mall_group"].checkMall;
  checkMall?.Id && (data.branchGroupRelId = checkMall.Id);
  data.order_by = "-CreateTime";
  const url = "/moveLog/list";
  const r = await COU_httpGet({ url, data });
  let list = [],
    total = 0,
    msg = "";
  try {
    list = r.result.Datas;
    total = r.result.TotalNum;
    msg = r.msg;
  } catch (error) {
    console.log(error);
  }
  if (!list) list = [];
  else {
    list.map((item) => {
      item.Title = item.Title.replaceAll("\u0000", "");
      if ([2, 3].includes(item.Status)) item.StatusStr = `铺货${item.StatusStr}`;
      if (item.FinishTime === "2000-01-01 00:00:00") item.FinishTime = "";
    });
  }
  return { list, total, msg };
}

// 删除上货记录
async function DeleteLog(id) {
  // 如果是多店铺模式的话要传branchGroupRelId
  const checkMall = store.state["mall_group"].checkMall
  const url = "/moveLog/delete";
  const r = await COU_httpPost({ url, data: { moveLogId: id, branchGroupRelId: checkMall?.Id || null } });
  let msg = "",
    success = false;
  try {
    msg = r.msg;
    success = r.success;
  } catch (error) {
    console.log(error);
  }
  return { success, msg };
}

// 获取商品审核状态
async function GetAuditStatusResult(moveLogIds) {
  // 如果是多店铺模式的话要传branchGroupRelId
  const checkMall = store.state["mall_group"].checkMall
  const url = "/moveLog/auditStatusQuery";
  const r = await COU_httpPost({ url, data: { moveLogIds, branchGroupRelId: checkMall?.Id || null } });
  let msg = "",
    success = false,
    result = {};
  try {
    msg = r.msg;
    success = r.success;
    result = r.result;
  } catch (error) {
    console.log(error);
  }
  return { success, msg, result };
}

// 同步成功铺货的商品库存价格
async function SyncGoodsPriceAndStock(data) {
  // 如果是多店铺模式的话要传branchGroupRelId
  const checkMall = store.state["mall_group"].checkMall
  checkMall?.Id && (data.branchGroupRelId = checkMall.Id)
  // 该接口必传branchRelId (1688的授权关联Id)
  data.branchRelId = Service_GetBranchRelId(checkMall?.Id ? checkMall : null)
  const url = '/moveLog/syncMoveLogProductPriceAndStock'
  const r = await COU_httpPost({ url, data })
  let msg = '', success = false
  try {
    msg = r.msg
    success = r.success
  } 
  catch (error) {
    console.log(error)
  }
  return { success, msg }
}

export default {
  GetLogList,
  DeleteLog,
  GetAuditStatusResult,
  SyncGoodsPriceAndStock
};
